import React, {Component} from 'react'
import {sessionItemVal, strVal} from '../../../../modules/Utils'
import {Col, Icon, Modal, Row, Tag, Tooltip} from 'antd'
import StaffStatus from '../../../../elements/StaffStatus'
import {compose, withState} from 'recompose'
import withSpinning from '../../../../elements/HOC/withSpinning'
import AccountDropdown from '../../../Common/AccountDropdown'
import CompanyChartCont from '../../../People/CompanyChartCont'
import CustomSpin from '../../../../elements/CustomSpin'
import moment from 'moment'
import {Link} from 'react-router-dom'

class AttendanceHeader extends Component {
  tick() {
    this.setState({
      date: new Date(),
    })
  }

  state = {date: new Date()}

  componentDidMount() {
    this.interval = setInterval(() => this.tick(), 1000)
  }

  render() {
    const {
      status,
      location,
      member,
      updating,
      actions,
      visible,
      setVisible,
      lastUpdate,
      operations,
    } = this.props

    return (
      <Row style={{width: '100%'}}>
        <Row>
          <Modal
            title={'Organisation'}
            footer={null}
            visible={visible}
            width={1400}
            onCancel={() => setVisible(false)}>
            <CompanyChartCont />
          </Modal>
          <Col span={20}>
            <AccountDropdown
              {...{
                member,
                actions,
                operations,
              }}
            />
          </Col>
          <Col span={4}>
            <div style={{float: 'right'}}>
              <Tooltip title="Organisation Chart">
                <a onClick={() => setVisible(v => !v)}>
                  <Icon type="team" />
                </a>
              </Tooltip>
            </div>
          </Col>
        </Row>
        <Row>
          <CustomSpin spinning={updating}>
            <StaffStatus
              className={'ant-list-item-meta-title'}
              style={{marginLeft: 40}}
              value={sessionItemVal('attendance_status_dropdown', status)}
              _key={status}
            />
            <span style={{float: 'right'}}>
              {strVal(location, 'country.countryName')}
            </span>
            <br />
            {/*<Tooltip title="Time spent since last Update">*/}
            {/*<span style={{marginLeft: 40}}>*/}
            {/*{moment*/}
            {/*.utc(moment(this.state.date).diff(moment(lastUpdate)))*/}
            {/*.format('HH:mm:ss')}*/}
            {/*</span>*/}
            {/*</Tooltip>*/}
          </CustomSpin>
        </Row>
        <br />
        <Row>
          <Tag color="gold">
            <Link to={'/account#password'}>My Account</Link>
          </Tag>
          <Tag color="magenta">
            <Link to={'/account#claim'}>My Claims</Link>
          </Tag>
          <Tag color="green">
            <Link to={'/account#leave'}>My Leaves</Link>
          </Tag>
        </Row>
      </Row>
    )
  }
}

AttendanceHeader.propTypes = {}
AttendanceHeader.defaultProps = {}

export default compose(
  withSpinning,
  withState('visible', 'setVisible', false),
)(AttendanceHeader)
